<template>
  <div class="page-container content-430">
    <Alert show-icon>
      <div class="alert-top">
        <span>班级名称：<i class="classname-text">{{ classroomName }}</i></span>
      </div>
      <div>根据每月实际开课纪录，选中学生考勤纪录可批量修改、补录</div>
    </Alert>
    <div class="action-block">
      <!-- <div class="block-left">
        <span>班级名称：{{ classroomName }}</span>
      </div> -->
      <div class="block-center">
        <span>选择月份：</span>
        <DatePicker
          v-model="selectMonDate"
          type="month"
          placeholder="请选择月份"
          style="width: 120px"
          format="yyyy-MM"
          transfer
          @on-change="changeMonth"
        ></DatePicker>
        <Input
          v-model="studentName"
          placeholder="请输入学生姓名"
          style="width: 130px; margin-left: 8px"
          clearable
        ></Input>
        <Button
          type="primary"
          style="margin-left: 8px"
          @click="handleSearchList"
        >搜索</Button>
        <div class="checkbox">
          <Checkbox
            v-model="studentSts"
            @on-change="handleCheckChange"
          >不含离班学生</Checkbox>
          <Tooltip
            content="学生全额退款后，将自动从班级学生名单中离班"
            max-width="300"
            placement="top"
          >
            <Icon type="ios-help-circle-outline" size="18"></Icon>
          </Tooltip>
        </div>
      </div>
      <div v-if="canOperateData" class="block-right">
        <RadioGroup v-model="actionValue">
          <Radio
            v-for="(item, index) in actionsListShow"
            :key="index"
            :label="item.value"
          >
            {{ item.name }}
          </Radio>
        </RadioGroup>
        <Button
          type="primary"
          :disabled="actionBtnDisabled"
          :loading="btnLoading"
          @click="handleEditStatus"
        >批量修改</Button>
      </div>
    </div>
    <div class="table-box">
      <Table
        ref="recordTable"
        border
        :max-height="500"
        :loading="loadingRecord"
        :disabled-hover="true"
        :columns="tableColumnShow"
        :data="tableData"
      ></Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="getNewPage"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="showSettingReasonModal"
      :width="500"
      title="设置请假原因"
      :footer-hide="true"
    >
      <div>请假原因</div>
      <Input
        v-model="leaveReason"
        :rows="3"
        maxlength="20"
        show-word-limit
        type="textarea"
        placeholder="请输入请假原因"
        style="width: 400px"
      ></Input>
      <div class="operation-430">
        <Button class="search-430" @click="handleCancel">取消</Button>
        <Button
          class="search-430"
          type="primary"
          @click="handleChangeLeaveReason"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import {
  signStatusList,
  changeDictionaries,
  weekList,
  hasRefundTallyStsList
} from '@/utils/dictionary.js';
import { isPassExpectTime } from '@/utils/utils.js';
export default {
  data() {
    return {
      classroomId: '', // 班级id
      classroomName: '', // 班级名称
      actionValue: 1,
      // 操作列表单选
      actionsList: [
        {
          value: 1,
          name: '修改为已签到'
        },
        {
          value: 2,
          name: '修改为请假'
        },
        {
          value: 4,
          name: '修改为请假（可退款）'
        },
        {
          value: 3,
          name: '修改为未签到'
        },
        {
          value: 5,
          name: '修改为缺勤'
        }
      ],
      tableColumn: [
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 100,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column table-left-column-font',
          render: (h, params) => {
            const handleToAttendanceDetails = () => {
              this.handleToAttendanceDetails(params.row);
            };
            return h(
              'div',
              {
                on: {
                  // 单元格的点击事件
                  click: handleToAttendanceDetails
                }
              },
              [`${params.row.studentName}`]
            );
          }
        },
        {
          title: '年级',
          key: 'gradeName',
          minWidth: 100,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column'
        },
        {
          title: '行政班',
          key: 'className',
          minWidth: 100,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column'
        }
      ],
      tableColumnShow: [],
      tableData: [],
      courseList: [], // 每个月的课程表
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      pageSizeOpts: [10, 20, 50, 100],
      selectCellList: [], // 选中的表格单元格
      selectMonDate: null, // 选择哪个月份
      selectMonStr: '',
      beginDate: '', // 日期开始
      endDate: '', // 日期结束
      weekList: changeDictionaries(weekList),
      studentName: '', // 学生姓名
      portOrg: -1, // 现在登录的是哪个端口
      loadingRecord: false, // 是否在加载考勤记录
      showRefundOption: true, // 是否展示请假可退款选项
      status: -1,
      selectColumnDetailIdList: [], // 选中列的DetailId列表
      showSettingReasonModal: false, // 是否展示设置原因的弹窗
      leaveReason: '',
      selectReasonSignId: '', // 要改变请假理由的signid
      studentSts: true, // 不含离班
      btnLoading: false,
      yearCode: '',
      termCode: '',
      schoolId: ''
    };
  },
  computed: {
    // 批量操作按钮是否禁止点击
    actionBtnDisabled() {
      if (this.selectCellList.length > 0) {
        return false;
      }
      return true;
    },
    // 是否可以操作数据
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if ((this.portOrg === 0 || this.portOrg === 2) && this.status === 1) {
        return true;
      }
      return false;
    },
    actionValueStr() {
      let str = '';
      switch (Number(this.actionValue)) {
        case 1:
          str = '修改为已签到';
          break;
        case 2:
          str = '修改为请假';
          break;
        case 3:
          str = '修改为未签到';
          break;
        case 4:
          str = '修改为请假（可退款）';
          break;
        case 5:
          str = '修改为缺勤';
          break;
        default:
          break;
      }
      return str;
    },
    actionsListShow() {
      return [
        {
          value: 1,
          name: '修改为已签到'
        },
        {
          value: 2,
          name: '修改为请假（不退款）'
        },
        {
          value: 4,
          name: '修改为请假（可退款）'
        },
        // {
        //   value: 3,
        //   name: '修改为未签到'
        // }
        {
          value: 5,
          name: '修改为缺勤'
        }
      ];
    }
  },
  watch: {
    // 日期改变之后---
    selectMonStr(newVal) {
      if (!newVal) {
        return;
      }
      const arr = this.selectMonStr.split('-');
      const days = new Date(arr[0], arr[1], 0).getDate();
      this.beginDate = `${this.selectMonStr}-01 00:00:00`;
      this.endDate = `${this.selectMonStr}-${days} 23:59:59`;
      this.getAttenDanceList();
    },
    // 切换状态的时候,将已选择的清空
    actionValue(newVal) {
      this.selectCellList = [];
      this.selectColumnDetailIdList = [];
      console.log(this.tableData);
      if (newVal === 4) {
        const content = `<p>（1）标记成：请假（可退款）将自动为学生生成一条请假单，并<span style="color:red">自动审批通过</span>且设置成<span style="color:red">该节次可退款，</span>标记后，该考勤状态不可修改，请设置前仔细核对。</p><p>（2）若意外操作导致退款，可通过：<span style="color:red">教务中心</span>--<span style="color:red">学生请假</span>--<span style="color:red">设置请假单</span>可退款状态。</p>`;
        this.$Modal.info({
          title: '提示',
          content: content
        });
      }
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.classroomId = this.$route.query.classroomId;
    this.studentName = this.$route.query.studentName
      ? this.$route.query.studentName
      : '';
    this.getClassroomDetails();
    this.getNowDayStr();
  },
  methods: {
    // 获取课程详情，主要是要里面的 yearCode和termCode
    async getClassroomDetails() {
      const res = await courseSchedulCenter.getClassPartitionDetails({ classroomId: this.classroomId });
      if (res.status === 200) {
        this.yearCode = res.message.yearCode;
        this.termCode = res.message.termCode;
        this.schoolId = res.message.schoolId;
      }
    },
    // 一进来获取当前日期
    getNowDayStr() {
      this.selectMonDate = new Date();
      const year = this.selectMonDate.getFullYear();
      const month = this.selectMonDate.getMonth() + 1;
      this.selectMonStr = `${year}-${month > 9 ? month : '0' + month}`;
    },
    // 获取新的月份
    changeMonth(formatDate, type) {
      this.selectMonStr = formatDate;
      this.selectCellList = [];
      this.selectColumnDetailIdList = [];
    },
    // 处理日期
    dealDate(date) {
      if (!date) {
        return '-';
      }
      const theDate = new Date(date);
      const month = theDate.getMonth() + 1;
      const day = theDate.getDate();
      return `${month}月${day}日`;
    },
    // 点击搜索列表
    handleSearchList() {
      this.selectCellList = [];
      this.selectColumnDetailIdList = [];
      this.pageInfo.pageNum = 1;
      this.getAttenDanceList();
    },
    getNewPage(page) {
      this.selectCellList = [];
      this.selectColumnDetailIdList = [];
      this.pageInfo.pageNum = page;
      this.getAttenDanceList();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.selectCellList = [];
      this.selectColumnDetailIdList = [];
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getAttenDanceList();
    },
    // 获取考勤记录列表
    async getAttenDanceList() {
      const params = {
        classroomId: this.classroomId,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        studentSts: this.studentSts ? 1 : '' // 0 离班 1 在读 传空含离班数据
      };
      this.studentName ? (params.studentName = this.studentName) : '';
      try {
        this.loadingRecord = true;
        const res = await courseSchedulCenter.getAttendanceListApi(params);
        if (res.status === 200) {
          this.classroomName = res.message.classroomName;
          this.status = res.message.status;
          // 平安银行的不能展示 请假退款选项
          // this.showRefundOption = !!(
          //   res.message.school && res.message.school.areaCode === '440114'
          // );
          this.courseList = res.message.detailList;
          this.initColumn();
          this.dealStudentData(res.message.studentSignsOfMonthPage.list);
          this.pageInfo.total = Number(
            res.message.studentSignsOfMonthPage.total
          );
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingRecord = false;
      }
    },
    // 初始化表头
    initColumn() {
      let columnList = [];
      this.courseList.forEach(item => {
        const obj = {
          title: this.dealDate(item.classDate),
          key: item.detailId,
          minWidth: 120,
          align: 'center',
          className: 'table-status-column cursor-pointer',
          renderHeader: (h, { column, index }) => {
            const clickTableHeader = () => {
              this.handleClickTableColumn(item.detailId, item.classTimeBegin);
            };
            return h(
              'div',
              {
                class: {
                  'table-head-item': true,
                  'table-head-item-active': this.judgeColumnIsActive(
                    item.detailId
                  )
                },
                on: {
                  click: clickTableHeader
                }
              },
              [
                h('div', [this.dealDate(item.classDate)]),
                h('div', [this.weekList[item.classWeekDate]])
              ]
            );
          },
          render: (h, { row, column, index }) => {
            const clickTableItem = () => {
              this.handleClickTableItem(row[item.detailId], row.studentId);
            };
            const clickLeave = signId => {
              this.handleOpenChangeModal(signId);
            };
            console.log(row, '拿到的封面类----------');
            return h(
              'div',
              {
                class: {
                  'cursor-pointer': true,
                  'table-item': true,
                  'table-item-column': (row[item.detailId] && (row[item.detailId].tallySts === 1 || row[item.detailId].tallySts === 3 || row[item.detailId].tallySts === 4)) || (row[item.detailId] && (row[item.detailId].tallySts === 8 || hasRefundTallyStsList.includes(row[item.detailId].tallySts)) && row[item.detailId].status === 4) || (row[item.detailId] && row[item.detailId].refundOrderId && +row[item.detailId].refundOrderId) || (row[item.detailId] && row[item.detailId].daycareDetailId && row[item.detailId].daycareDetailId !== '0'),
                  // 选项禁掉勾选（条件：1、工商银行请假可退款生成的请假；2、或者是考勤不在本班的；3、已退款的 tallySts ）
                  'table-item-disabled':
                    (row[item.detailId] &&
                      (hasRefundTallyStsList.includes(row[item.detailId].tallySts) ||
                        row[item.detailId].tallySts === 8)) ||
                    !row[item.detailId] || (row[item.detailId] && row[item.detailId].refundOrderId && (+row[item.detailId].refundOrderId) && this.actionValue === 4) || ((row[item.detailId].tallySts === 1 || row[item.detailId].tallySts === 3 || row[item.detailId].tallySts === 4) && this.actionValue === 4), // isRetMoney 0非请假可退款 1请假可退款
                  // 点击选中的类名(勾选的时候选中的样式)
                  'table-item-active': row[item.detailId]
                    ? this.judgeItemIsActive(row[item.detailId].signId)
                    : false,
                  // 列批量勾选的时候每个项的样式（两边的红线）
                  'table-column-item-active': this.judgeColumnIsActive(
                    item.detailId
                  ),
                  // 列批量勾选的时候最后一个项的样式 border-bottom有红线
                  'table-column-item-active-last':
                    this.judgeColumnIsActive(item.detailId) &&
                    this.tableData.length === index + 1,
                  // 考勤不在本班的时候，整体字体要变小，不然塞不下
                  'table-item-small': !row[item.detailId],
                  // 未签到的，红色字体
                  'table-item-nosign':
                    row[item.detailId] &&
                    (row[item.detailId].status === 0 ||
                      row[item.detailId].status === 1),
                  // 请假的，紫色字体
                  'table-item-leave':
                    row[item.detailId] && row[item.detailId].status === 4,
                  'table-item-absence':
                    row[item.detailId] && row[item.detailId].status === 5
                },
                on: {
                  // 单元格的点击事件
                  click: clickTableItem
                }
              },
              [
                // 项里面 的 文字显示：有detailId而且tallySts的显示 已退款(剔除请假可退款的，请假可退款请假成功仍然要显示已请假)；其他的，根据字典组的配置显示，没有detailId的是考勤不在本班
                row[item.detailId] &&
                 hasRefundTallyStsList.includes(row[item.detailId].tallySts) &&
                  row[item.detailId].status !== 4
                  ? '已退款'
                  : changeDictionaries(signStatusList)[
                    row[item.detailId] ? row[item.detailId].status : 7
                  ],
                // 选中的时候右上角的对勾
                h(
                  'div',
                  {
                    class: 'table-item-icon'
                  },
                  [
                    h('Icon', {
                      props: {
                        type: 'md-checkmark',
                        color: '#ffffff',
                        size: 25
                      }
                    })
                  ]
                ),
                // 当选中项是想要修改为 请假可退款（或者请假生成请假单的），下方会多一个小格子用来修改请假的备注
                h(
                  'div',
                  {
                    class: {
                      'table-item-leave': true,
                      'table-item-leave-active':
                        (this.actionValue === 4 || this.actionValue === 2) &&
                        (row[item.detailId]
                          ? this.judgeItemIsActive(row[item.detailId].signId)
                          : false)
                    },
                    on: {
                      click: event => {
                        if (
                          (this.actionValue === 4 || this.actionValue === 2) &&
                          this.judgeItemIsActive(row[item.detailId].signId)
                        ) {
                          row[item.detailId]
                            ? clickLeave(row[item.detailId].signId)
                            : '';
                          event.stopPropagation();
                        }
                      }
                    }
                  },
                  // 请假的备注在格子里显示最多4个字，多的用...表示
                  [
                    row[item.detailId]
                      ? this.showLeaveReason(row[item.detailId].signId)
                      : ''
                  ]
                ),
                // 请假可退款要增加可退款的显示标志
                h(
                  'div', {
                    class: {
                      'table-item-leave-refund': true
                    }
                  },
                  [
                    row[item.detailId] && hasRefundTallyStsList.includes(row[item.detailId].tallySts) &&
                        row[item.detailId].status === 4 ? '（已退款）'
                      : ((row[item.detailId] && row[item.detailId].tallySts === 8)) &&
                      row[item.detailId].status === 4 ? '（可退款）' : ''
                  ]
                ),
                (row[item.detailId] && !hasRefundTallyStsList.includes(row[item.detailId].tallySts)) && row[item.detailId].refundOrderId && +row[item.detailId].refundOrderId ? h(
                  'div', {
                    class: {
                      'table-item-wait-refund': true
                    }
                  },
                  [
                    '（待退款）'
                  ]
                ) : '',
                (row[item.detailId] && (row[item.detailId].tallySts === 1 || row[item.detailId].tallySts === 3 || row[item.detailId].tallySts === 4)) ? h(
                  'div', {
                    class: {
                      'table-item-wait-refund': true
                    }
                  },
                  [
                    '（已结算）'
                  ]
                ) : ''

              ]
            );
          }
        };
        columnList.push(obj);
      });
      if (columnList.length === 0) {
        columnList = [
          {
            title: '本月无课程',
            key: '-',
            minWidth: 120,
            align: 'center',
            className: 'table-status-column'
          }
        ];
      }
      this.tableColumnShow = this.tableColumn.concat(columnList);
    },
    // 处理学生数据
    dealStudentData(originDataList) {
      this.tableData = originDataList.map(item => {
        item.signList.forEach(x => {
          x.signStateShow = x.signState;
          x.daycareDetailId && x.daycareDetailId !== '0' ? x.detailId = x.daycareDetailId : '';
          // signState 0和1 都是表示未开始未签到，根据距离开始上课时间是否小于30分钟，来判断是否可以改为已签到
          if (+x.signState === 0 || +x.signState === 1) {
            const tag = isPassExpectTime(x.classTimeBegin, 30);
            tag ? (x.signStateShow = 1) : (x.signStateShow = 0);
          }
          item[x.detailId] = {
            classId: x.classId,
            classroomId: x.classroomId,
            status: x.signStateShow,
            detailId: x.detailId,
            signId: x.id,
            // leaveState: x.leaveState,
            lockState: x.lockState, // （是否可以修改退款：1不能改,0能改） 月份账单是否已生成而且可以已确认
            tallySts: x.tallySts, // 退款状态 5：已退款
            // isRetMoney: x.isRetMoney,
            refundOrderId: x.refundOrderId,
            daycareDetailId: x.daycareDetailId
          };
        });
        return item;
      });
      console.log(this.tableData, '表格数据----232443');
    },
    // 点击表格的某项
    handleClickTableItem(status, studentId) {
      if (this.btnLoading) {
        return;
      }
      console.log(status, studentId, '点击表格某项-----');
      // return;
      // 不能修改数据的点击不进行任何操作
      if (!this.canOperateData) {
        return;
      }
      if (!status) {
        return;
      }
      // 如果请假是从学生请假管理中同步过来的，则不可修改考勤状态。单元格不可点击 leaveState 1 就是此状态, status 4:已请假
      // if (
      //   status.leaveState === 1 &&
      //   status.status === 4) {
      //   return;
      // }
      // tallySts 退款状态为 5、6、7或者8的，不可点击
      if (hasRefundTallyStsList.includes(status.tallySts) || status.tallySts === 8) {
        return;
      }

      if (!this.judgeStatusCanChange(status.status)) {
        return;
      }
      if (this.actionValue === 4 && (status.tallySts === 1 || status.tallySts === 3 || status.tallySts === 4)) {
        // this.$Message.error('已结算的不能修改为请假（可退款）!');
        return;
      }
      if (this.actionValue === 4 && status.refundOrderId && +status.refundOrderId !== 0) {
        // this.$Message.error('待退款的不能修改为请假（可退款）!');
        return;
      }
      // if (this.selectColumnDetailIdList.length === 5) {
      //   this.$Message.error('已批量选中5列！');
      //   return;
      // }
      const tag = this.judgeItemIsActive(status.signId);
      // 已选中的，点击就剔除，未选中的,如果不超过200条，点击就添加，否则就提示
      if (tag) {
        this.selectCellList = this.selectCellList.filter(item => {
          return (
            item.studentId !== studentId || item.detailId !== status.detailId
          );
        });
      } else if (this.selectCellList.length >= 200) {
        this.$Message.error('单次最多限制处理200条数据');
      } else {
        const obj = {
          studentId,
          detailId: status.detailId,
          signId: status.signId,
          classroomId: status.classroomId,
          classId: status.classId,
          lockState: status.lockState
        };
        (this.actionValue === 4 || this.actionValue === 2) ? (obj.leaveDescribe = '请假') : '';
        this.selectCellList.push(obj);
      }
      // 已选中的，点击就剔除，未选中的，点击就添加
      // if (!this.judgeItemIsActive(status.signId)) {
      //   const obj = {
      //     studentId,
      //     detailId: status.detailId,
      //     signId: status.signId,
      //     classroomId: status.classroomId,
      //     classId: status.classId,
      //     lockState: status.lockState
      //   };
      //   (this.actionValue === 4 || this.actionValue === 2) ? (obj.leaveDescribe = '请假') : '';
      //   this.selectCellList.push(obj);
      // } else {
      //   this.selectCellList = this.selectCellList.filter(item => {
      //     return (
      //       item.studentId !== studentId || item.detailId !== status.detailId
      //     );
      //   });
      // }
    },
    // 点击表格的某列
    handleClickTableColumn(detailId, classTimeBegin) {
      if (this.btnLoading) {
        return;
      }
      // 不能修改数据的点击不进行任何操作
      if (!this.canOperateData) {
        return;
      }
      if (!isPassExpectTime(classTimeBegin, 30) && this.actionValue === 1) {
        this.$Message.error('当前选择节次还未到可以签到时间');
        return;
      }
      const detailIdIndex = this.selectColumnDetailIdList.findIndex(item => {
        return item === detailId;
      });
      if (this.selectCellList.length >= 200 && detailIdIndex === -1) {
        this.$Message.error('单次最多限制处理200条数据');
        return;
      }
      // if (this.selectColumnDetailIdList.length === 5 && detailIdIndex === -1) {
      //   this.$Message.error('批量选中一次不得超过5列！');
      //   return;
      // }
      let selectTag = false; // 是否是选中状态（true:选中；false:未选中）
      // 该列是否已选中 detailIdIndex为-1时就是改列没选中
      const tempList = [];
      if (detailIdIndex === -1) {
        // this.selectColumnDetailIdList.push(detailId);
        selectTag = true;
      } else {
        this.selectColumnDetailIdList.splice(detailIdIndex, 1);
        selectTag = false;
      }
      this.tableData.forEach(item => {
        // console.log('拿到的考勤状态', item, '=======');
        // 如果本节课该学生没有任何考勤信息的，就不要再继续下去
        if (!item[detailId]) {
          return;
        }
        // 如果请假是从学生请假管理中同步过来的，则不可修改考勤状态。单元格不可点击 leaveState 1 就是此状态
        // if (
        //   item[detailId].leaveState === 1 &&
        //   item[detailId].status === 4) {
        //   return;
        // }
        // tallySts 退款状态为 5、6、7或者8的，不可点击
        if (hasRefundTallyStsList.includes(item[detailId].tallySts) || item[detailId].tallySts === 8) {
          return;
        }
        const obj = {
          studentId: item.studentId,
          detailId,
          signId: item[detailId].signId,
          classroomId: item[detailId].classroomId,
          classId: item[detailId].classId,
          lockState: item[detailId].lockState
        };
        if (!this.judgeStatusCanChange(item[detailId].status, false)) {
          return;
        }
        // 已结算的不能选中去进行退款
        if (this.actionValue === 4 && (item[detailId].tallySts === 1 || item[detailId].tallySts === 3 || item[detailId].tallySts === 4)) {
          return;
        }
        // 有待退款单的不能去进行退款
        if (this.actionValue === 4 && item[detailId].refundOrderId && +item[detailId].refundOrderId !== 0) {
          return;
        }
        // 每个小项，已选中的就剔除，未选中的就添加
        if (!this.judgeItemIsActive(item[detailId].signId) && selectTag) {
          (this.actionValue === 4 || this.actionValue === 2) ? (obj.leaveDescribe = '请假') : '';
          // this.selectCellList.push(obj);
          tempList.push(obj);
        } else if (
          this.judgeItemIsActive(item[detailId].signId) &&
          !selectTag
        ) {
          this.selectCellList = this.selectCellList.filter(x => {
            return x.studentId !== item.studentId || detailId !== x.detailId;
          });
        }
      });
      if (selectTag && (tempList.length + this.selectCellList.length) > 200) {
        this.$Message.error('单次最多限制处理200条数据');
      } else if (selectTag) {
        this.selectCellList = this.selectCellList.concat(tempList);
        this.selectColumnDetailIdList.push(detailId);
      }
    },
    // 判断当前列是否是选中状态
    judgeColumnIsActive(detailId) {
      const index = this.selectColumnDetailIdList.findIndex(item => {
        return item === detailId;
      });
      return index >= 0;
    },
    // 判断当前项是否是选中状态
    judgeItemIsActive(signId) {
      const index = this.selectCellList.findIndex(item => {
        return item.signId === signId;
      });
      return index >= 0;
    },
    // 判断当前状态是否能修改成别的状态
    judgeStatusCanChange(status, showToast = true) {
      console.log('修改为别的状态，', status, showToast);
      // status 0未开始1未考勤2签到3签退4请假5缺席6停课
      // actionValue(选中哪个选项) 1:改为已签到 2:改为已请假 3:改为未签到 4:改为已请假(可退款) 5
      // （备注）actionValue 2、4的判断条件一致

      // return true

      let clickStatus = false;

      console.log(this.actionValue, status);
      switch (Number(status)) {
        // 未开始的考勤状态 (未开始可以去请假)
        case 0:
          clickStatus = this.actionValue === 2 || this.actionValue === 4;
          break;
        // 未签到的考勤状态 （未签到可以去 签到、请假、或者标记为缺勤）
        case 1:
          clickStatus =
            this.actionValue === 1 ||
            this.actionValue === 2 ||
            this.actionValue === 4 || this.actionValue === 5;
          break;
        // 签退的考勤状态
        case 3:
          clickStatus = this.actionValue === 1 || this.actionValue === 5;
          break;

        case 2:
          clickStatus = this.actionValue === 2 || this.actionValue === 4 || this.actionValue === 3 || this.actionValue === 5;
          break;
        // 已请假考勤状态
        case 4:
          clickStatus = this.actionValue === 1 || this.actionValue === 5;
          break;
        // 缺勤的考勤状态
        case 5:
          clickStatus =
            this.actionValue === 1 ||
            this.actionValue === 2 ||
            this.actionValue === 4;
          break;
      }
      if (!clickStatus && showToast) {
        this.$Message.error(`当前状态无法${this.actionValueStr}`);
      }
      return clickStatus;
    },
    // 点击学生名称跳转到 学生考勤明细页面
    handleToAttendanceDetails(row) {
      console.log(row, 'payOrderId');
      if (this.portOrg == 1) {
        return null;
      }
      const { href } = this.$router.resolve({
        name: 'eduCenter_studentAttance_Index_Details',
        query: {
          classroomId: this.classroomId,
          stuId: row.studentId,
          payOrderId: row.payOrderId,
          studentName: row.studentName,
          studentSts: row.studentSts
        }
      });
      window.open(href);
    },
    // 批量修改状态
    handleEditStatus() {
      const index = this.selectCellList.findIndex(item => {
        return +item.lockState > 0;
      });
      // lockState 1：不能改 0：能改
      if (index > -1 && +this.actionValue === 4) {
        return this.$Message.error('课程节次已生成账单，不可调整考勤状态！');
      }
      this.btnLoading = true;
      const signIds = this.selectCellList.map(item => {
        return item.signId;
      });
      const params = {
        // classroomId: this.classroomId,
        yearCode: this.yearCode,
        termCode: this.termCode,
        schoolId: this.schoolId,
        signIds
      };
      switch (Number(this.actionValue)) {
        // 改为已签到
        case 1:
          this.changeToSigned(params);
          break;
        // 改为请假
        case 2:
          this.changeToLeave(params);
          break;
        // 改为未签到
        case 3:
          this.changeToNoChecking(params);
          break;
        // 改为请假可退款（工商银行）或者请假生成请假单（平安银行）
        case 4:
          this.changeToLeaveRefund(params);
          break;
        case 5:
          this.setSignToAbsent(params);
          break;
        default:
          this.btnLoading = false;
          break;
      }
    },
    // 改变成已签到
    async changeToSigned(params) {
      try {
        const res = await courseSchedulCenter.batchSetToSignedApi(params);
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.selectCellList = [];
          this.selectColumnDetailIdList = [];
          this.getAttenDanceList();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成已请假
    async changeToLeave(params) {
      try {
        const list = this.selectCellList.map(item => {
          return {
            ...item,
            classroomId: this.classroomId,
            retMoneyEnum: 'NOT_REFUND' // 可退款
          };
        });
        const res = await courseSchedulCenter.batchSaveLeaveApi(
          list
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.selectCellList = [];
          this.selectColumnDetailIdList = [];
          this.getAttenDanceList();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成已请假（可退款）
    async changeToLeaveRefund(params) {
      try {
        const list = this.selectCellList.map(item => {
          return {
            ...item,
            classroomId: this.classroomId,
            retMoneyEnum: 'CAN_REFUND' // 可退款
          };
        });
        // return;
        const res = await courseSchedulCenter.batchSaveLeaveApi(
          list
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.selectCellList = [];
          this.selectColumnDetailIdList = [];
          this.getAttenDanceList();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成未考勤
    async changeToNoChecking(params) {
      try {
        const res = await courseSchedulCenter.batchSetToNoCheckingApi(params);
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.selectCellList = [];
          this.selectColumnDetailIdList = [];
          this.getAttenDanceList();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    //
    async setSignToAbsent() {
      try {
        const signIds = this.selectCellList.map(item => {
          return item.signId;
        });
        const params = {
          // classroomId: this.classroomId,
          yearCode: this.yearCode,
          termCode: this.termCode,
          schoolId: this.schoolId,
          signIdList: signIds,
          forSignEnum: 5
        };
        const res = await courseSchedulCenter.setSignToAbsent(
          params
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.selectCellList = [];
          this.selectColumnDetailIdList = [];
          this.getAttenDanceList();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },

    // 展示请假理由
    showLeaveReason(signId, ellipsis = true) {
      if (this.actionValue !== 4 && this.actionValue !== 2) {
        return '';
      }
      const index = this.selectCellList.findIndex(item => {
        return item.signId === signId;
      });
      let leaveDescribe =
        index >= 0 ? this.selectCellList[index].leaveDescribe : '';
      if (leaveDescribe.length > 4 && ellipsis) {
        leaveDescribe = leaveDescribe.slice(0, 4) + '...';
      }
      return leaveDescribe;
    },
    // 打开改变请假理由的弹窗
    handleOpenChangeModal(signId) {
      this.selectReasonSignId = signId;
      this.leaveReason = this.showLeaveReason(signId, false);
      this.showSettingReasonModal = true;
    },
    // 改变请假理由
    handleChangeLeaveReason() {
      if (this.leaveReason === '') {
        this.$Message.error('请输入请假理由');
        return;
      }
      const index = this.selectCellList.findIndex(item => {
        return item.signId === this.selectReasonSignId;
      });
      if (index >= 0) {
        const obj = this.selectCellList[index];
        obj.leaveDescribe = this.leaveReason;
        this.selectCellList.splice(index, 1, obj);
      }
      this.showSettingReasonModal = false;
    },
    handleCancel() {
      this.showSettingReasonModal = false;
    },
    // 不含离班学生选择
    handleCheckChange(v) {
      this.getAttenDanceList();
    }
  }
};
</script>
<style lang="scss" scoped>
.alert-top {
  margin-bottom: 16px;
  .classname-text {
    font-style: normal;
    font-weight: bold;
  }
}
.action-block {
  display: flex;
  align-items: center;
  .block-center {
    // margin-left: 32px;
    .checkbox {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .block-right {
    margin-left: auto;
  }
}
.table-box {
  margin-top: 16px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
/deep/.ivu-table td.table-left-column {
  background: #f8f8f9;
}
/deep/.ivu-table td.table-left-column-font {
  color: #488ffa;
  cursor: pointer;
}
/deep/.ivu-table th.table-status-column {
  width: 100%;
  height: 100%;
  padding: 0;
  .ivu-table-cell {
    width: 100%;
    height: 100%;
    padding: 0;
    .table-head-item {
      padding: 8px 0;
    }
    .table-head-item-active {
      border-top: 1px solid red;
      border-left: 1px solid red;
      border-right: 1px solid red;
    }
  }
}
/deep/.ivu-table td.table-status-column {
  .ivu-table-cell {
    width: 100%;
    height: 100%;
    padding: 0;
    .table-item {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 20px 0;
      .table-item-icon {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 0;
        top: 0;
        background: #fff;
      }
      .table-item-leave {
        width: 100%;
        height: 18px;
        position: absolute;
        left: 0;
        bottom: 0;
        opacity: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        font-size: 12px;
      }
      .table-item-leave-active {
        opacity: 1;
        background: rgba(212, 211, 211, 0.3);
        color: #19be6b;
      }
    }
    .table-item-active {
      background: #f5f0ff;
      .table-item-icon {
        background: #d5c7ff;
      }
    }
    .table-item-nosign {
      color: red;
    }
    .table-item-leave {
      color: blue;
    }
    .table-item-absence {
      color: #63a103;
    }
    .table-item-small {
      font-size: 12px;
      color: #488ffa;
    }
    .table-column-item-active {
      border-left: 1px solid red;
      border-right: 1px solid red;
    }
    .table-column-item-active-last {
      border-bottom: 1px solid red;
    }
    .table-item-column {
      flex-direction: column;
      justify-content: center;
    }
    .table-item-leave-refund,.table-item-wait-refund {
      color: #444;
      margin-top: 4px;
    }
    .table-item-disabled {
      color: #c5c8ce;
      background-color: #f7f7f7;
      .table-item-icon {
        opacity: 0;
      }
    }
  }
}
</style>
<style>
.attendancerecord-active-item {
  width: 100%;
  height: 100%;
  border: 1px solid red;
}
</style>
